import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const removeVote = async (choice: string) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.pollChoices.vote(choice));
